'use strict';

import GeoObject from './geoObject';

function GeoLocation (object) {
  const location = object.get('location');

  this.suburb = location.get('isSuburb') || null;

  this.region = this.makeGeo(location, 'region');
  this.regionDistrict = this.makeGeo(location, 'regionDistrict');

  this.locality = this.makeGeo(location, 'locality');
  this.localityDistrict = this.makeGeo(location, 'localityDistrict');
  this.localityMicrodistrict = this.makeGeo(location, 'microdistrict');

  this.street = this.makeGeo(location, 'street');
  this.building = this.makeGeo(location, 'house');

  this.distanceFromCity = object.get('distanceFromCity') || null;

  /** @type {*|null} Ориентир */
  this.reference = object.get('reference') || null;

  this.lonLat = location.get('lonLat');
}

GeoLocation.REGION_KAZAN = 16;
GeoLocation.REGION_KRASNODAR = 23;
GeoLocation.REGION_NSK = 54;
GeoLocation.REGION_OMSK = 55;
GeoLocation.REGION_MOSCOW = 77;
GeoLocation.REGION_SPB = 78;

GeoLocation.prototype.makeGeo = function (location, key) {
  const data = location && location.get(key);

  if (!data) {
    return null;
  }

  return new GeoObject({
    id: data.get('id'),
    name: data.get('name'),
    fullName: data.get('fullName'),
    shortName: data.get('shortName')
  });
};

GeoLocation.prototype.getShortAddress = function () {
  const locality = this.getLocality() && this.getLocality().fullName;
  const streetName = this.getStreet() && this.getStreet().fullName;
  const houseName = this.getBuilding() && this.getBuilding().name;

  return [
    this.isSuburb() && locality,
    streetName,
    houseName
  ].filter(Boolean).join(', ');
};

/**
 * Возвращает область
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getRegion = function () {
  return this.region;
};

/**
 * Возврает район области
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getRegionDistrict = function () {
  return this.regionDistrict;
};

/**
 * Возвращает населенный пункт
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getLocality = function () {
  return this.locality;
};

/**
 * Возвращает район населенного пункта
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getLocalityDistrict = function () {
  return this.localityDistrict;
};

/**
 * возвращает микрорайон населеного пункта
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getLocalityMicrodistrict = function () {
  return this.localityMicrodistrict;
};

/**
 * Возвращает улицу
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getStreet = function () {
  return this.street;
};

/**
 * Возвращает строение
 * @returns {GeoObject|null}
 */
GeoLocation.prototype.getBuilding = function () {
  return this.building;
};

/**
 * Возвращает направление
 * @return GeoObject|null
 */
GeoLocation.prototype.getDirection = function () {

};

/**
 * Возвращает метро
 * @return GeoObject|null
 */
GeoLocation.prototype.getSubway = function () {

};

/**
 * Возвращает географические координаты объекта
 * @return GeoPoint|null
 */
GeoLocation.prototype.getGeoPoint = function () {
  return this.lonLat;
};

GeoLocation.prototype.isSuburb = function () {
  return this.suburb;
};

GeoLocation.prototype.getDistanceFromCity = function () {
  return this.distanceFromCity;
};

GeoLocation.prototype.getReference = function () {
  return this.reference;
};

export default GeoLocation;



// WEBPACK FOOTER //
// ./src/classes/geo/geoLocation.js